import {AuthSystem} from './auth-system'
import {path} from './routes'

declare let React: any
declare let ReactRouterDOM: any

const {withRouter} = ReactRouterDOM

interface ProtectedRouteProps {
  component: any
  location: any
  history: any
  [key: string]: any
}

const ProtectedRoute = withRouter(({component: Component, location, history, ...rest}: ProtectedRouteProps) => {
  const authSystem = AuthSystem.getInstance()
  
  console.log('🔒 ProtectedRoute - Verifica autenticazione per:', location.pathname)
  console.log('🔒 ProtectedRoute - Stato autenticazione:', authSystem.getAuthStatus())
  
  // Verifica se l'utente è autenticato
  if (!authSystem.isTokenValid()) {
    console.log('❌ ProtectedRoute - Utente non autenticato, reindirizzamento alla pagina di blocco')
    // Reindirizza alla pagina di blocco (senza fornire accesso al login)
    const blockedUrl = path(location, 'blocked')
    console.log('🚫 Reindirizzamento sicuro alla pagina di blocco:', blockedUrl)
    history.push(blockedUrl)
    return null
  }
  
  console.log('✅ ProtectedRoute - Utente autenticato, mostra componente')
  // Se autenticato, mostra il componente
  return <Component location={location} history={history} {...rest} />
})

export {ProtectedRoute} 